module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Red.ca493747.png";